<template>
  <context-menu v-if="accounts?.length > 1" :max-width="400">
    <template #activator>
      <e-btn variant="tonal" size="M" icon>+{{ accounts.length - 1 }}</e-btn>
    </template>
    <div class="accounts-menu__content">
      <router-link
        v-for="(account, index) in accounts"
        :key="index"
        :to="{ name: RouteNames.ObjectInfo, params: { id: objectId, acc_id: account.contractNumber } }"
        :class="{ disabled: account.status === ContractStatus.Closed }"
        class="py-2 px-4 accounts-menu__item"
      >
        <div class="d-flex flex-wrap paragraph-s">
          <b class="mr-2 mb-1">
            {{ account.contractNumber }}
          </b>
          <account-status :status="account.status" class="mb-1" />
        </div>
        <div class="paragraph-xs mt-1">
          {{ account.legal.name[0].value }}
        </div>
        <div class="d-flex align-center paragraph-xs mt-1">
          Оплата туроператором
          <vertical-line class="ml-2 mr-2" />
          {{ getCurrencyText(account.currencyISOCode) }}
        </div>
      </router-link>
    </div>
  </context-menu>
</template>

<script setup lang="ts">
import ContextMenu from '@/core/components/common/ContextMenu.vue';
import VerticalLine from '@/core/components/helpers/VerticalLine.vue';
import { EBtn } from '@/core/components/ui';
import { RouteNames } from '@/core/plugins/router/routeNames';
import { getCurrencyText } from '@/core/utils/currency';
import { ContractStatus, type ContractView } from '@/graphql/generated';
import AccountStatus from '@/parts/objects/components/AccountStatus.vue';

defineProps<{
  accounts: ContractView[];
  objectId: string;
}>();
</script>

<style scoped lang="scss">
.accounts-menu {
  &__content {
    color: $text-secondary-color;
  }

  &__item {
    display: block;

    border-radius: $border-radius;

    cursor: pointer;

    &.disabled {
      color: $text-ordinary-color;
    }

    @include hover {
      color: $text-primary-color;

      background-color: $primary-light-color;
    }
  }
}
</style>
